/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `CLOUDINARY` - Cloudinary
 */
export type ProviderEnum = typeof ProviderEnum[keyof typeof ProviderEnum];


export const ProviderEnum = {
  CLOUDINARY: 'CLOUDINARY',
} as const;
